export default "__VITE_ASSET__Gl6zD8jH__"